import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { DecimalPipe } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { TransactionDto } from '../../../dto/transactionDto';
import { TransactionSuccess } from '../../../enums/transaction-success.enum';
import { TableColumn } from '../../../models/tableColumn';
import { TableOptions } from '../../../models/tableOptions';
import { DEDatePipe } from '../../../pipes/de-date.pipe';
import { KwhPipe } from '../../../pipes/kwh.pipe';
import { ThousandPipe } from '../../../pipes/thousand.pipe';
import { TransactionsService } from '../../../services/entity/transactions.service';
import { RouteDataService } from '../../../services/route-data/route-data.service';


@Component({
  selector: 'app-dashboard-transactions',
  templateUrl: './dashboard-transactions.component.html',
  styleUrls: ['./dashboard-transactions.component.scss']
})
export class DashboardTransactionsComponent extends AbstractEntitiesTableComponent implements OnInit {

  public className = 'DashboardTransactionsComponent';

  public entities: TransactionDto[];

  public tableColumns: TableColumn[] = [
    { columnDescription: 'Trans-ID', property: 'id' },
    { columnDescription: 'Status', property: 'successMessage' },
    { columnDescription: 'Ladestation', property: 'chargingStationName' },
    { columnDescription: 'Vorname', property: 'userFirstName' },
    { columnDescription: 'Nachname', property: 'userLastName' },
    { columnDescription: 'kWh', property: 'meterAmount', options: { columnPipe: { pipe: new KwhPipe } } },
    { columnDescription: 'Datum', property: 'startTimestamp', options: { columnPipe: { pipe: new DEDatePipe() } } },
  ];

  public tableOptions: TableOptions = { hideActions: true, hideSearch: true };

  public isUser: boolean = false;
  public isCustomer: boolean = false;
  public isOperator: boolean = false;
  public isSupporter: boolean = false;

  constructor(
    public transactionsService: TransactionsService, 
    private routeDataService: RouteDataService, 
    injector: Injector
  ) {
    super(transactionsService, injector);
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Operator')) this.isOperator = true;
    if (this.authenticationService.userHasRole('Customer')) this.isCustomer = true;
    if (this.authenticationService.userHasRole('User')) this.isUser = true;
    this.isSupporter = this.authenticationService.userHasRole('Supporter')
  }

  async initializeEntities() {
    this.getRoles();

    if (this.isOperator)
    {
      this.transactionsService.getTransactionsOfLast7DaysOfCustomer(this.activatedRoute.parent.snapshot.params.key).subscribe(result => {
        this.entities = result
        this.mapSuccessMessage();
  
        this.tableFunctions.sortColumn = 'startTimestamp';
        this.tableFunctions.sortDirection = 'desc';
  
        super.setupTable();
      }, error => {});
    }
    else
    {
      this.transactionsService.getTransactionsOfLast7Days().subscribe(result => {
        this.entities = result
        this.mapSuccessMessage();
  
        this.tableFunctions.sortColumn = 'startTimestamp';
        this.tableFunctions.sortDirection = 'desc';
  
        super.setupTable();
      }, error => {});
    }

  }

  mapSuccessMessage() {
    for (let lastTransactionsDto of this.entities) {
      lastTransactionsDto.successMessage = TransactionSuccess[lastTransactionsDto.success];
    }
  }

  matches(entity: TransactionDto, term: string) {
    return TransactionsService.matches(entity, term);
  }

}
